import { render, staticRenderFns } from "./view-details.vue?vue&type=template&id=13145adb&scoped=true&"
import script from "./view-details.vue?vue&type=script&lang=js&"
export * from "./view-details.vue?vue&type=script&lang=js&"
import style0 from "./view-details.vue?vue&type=style&index=0&id=13145adb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13145adb",
  null
  
)

export default component.exports